// 瀏覽器分頁標題的「對象」（SPEC #vms-web-327：設備詳細頁「<設備名> · 設備 · <品牌 VMS>」；第二輪 B2-22）。
// 頁面設對象、殼層（Shell）組標題；頁面離開時清掉。
import { useEffect, useSyncExternalStore } from 'react';

let subject = '';
const subs = new Set<() => void>();

function set(s: string) {
  if (s === subject) return;
  subject = s;
  for (const f of subs) f();
}

/** 頁面用：這一頁的對象名稱（空字串 = 沒有）。 */
export function usePageSubject(name: string | undefined): void {
  useEffect(() => {
    set(name ?? '');
    return () => set('');
  }, [name]);
}

/** 殼層用。 */
export function usePageSubjectValue(): string {
  return useSyncExternalStore(
    (f) => {
      subs.add(f);
      return () => subs.delete(f);
    },
    () => subject,
    () => subject,
  );
}

/** 分頁標題：「<對象> · <頁名> · <品牌>」，沒有對象就「<頁名> · <品牌>」，載入中只寫品牌。 */
export function pageTitle(brand: string, page: string, subj: string, booting: boolean): string {
  // 沒有選單項目的頁（404）有對象就寫「找不到這一頁 · 品牌」（第三輪 B3-18）
  if (booting || (!page && !subj)) return brand;
  return [subj, page, brand].filter(Boolean).join(' · ');
}
